import styled from 'styled-components';
import {
  screenSize,
  whiteColor,
  inputBorderColor,
  mediumFont,
  primaryColor,
  inputBackgroundColor,
  inputBackgroundHoverColor,
} from '@app/styles';

type Props = {
  ErrorInput?: boolean;
  noBottom?: boolean;
  backgroundColor?: string;
};
export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
  .react-tel-input {
    .special-label {
      display: none;
    }
    .form-control {
      width: 100%;
      border: 2px solid #ccc;
      &:active,
      &:focus {
        background-color: ${whiteColor};
        border-color: ${primaryColor};
      }
    }
  }
  input {
    width: 100%;
    height: 48px;
    padding: 10px 12px;
    font-size: 16px;
    border: 2px solid ${inputBorderColor};
    border-radius: 4px;
    color: #2d3448;
    box-shadow: none;
    outline: none;
    -webkit-appearance: none;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
    @media (${screenSize.tablet}) {
      font-size: 15px;
      background-color: ${inputBackgroundColor};
      border-color: ${inputBorderColor};
      &:hover {
        background-color: ${inputBackgroundHoverColor};
      }
      &:active,
      &:focus {
        background-color: ${whiteColor};
        border-color: ${primaryColor};
      }
    }
  }
  ${({ noBottom }: Props) => {
    if (noBottom) {
      return `margin-bottom:0px;`;
    }
  }}
`;
export const InputComponent = styled.input`
  width: 100%;
  height: 44px;
  margin-top: 5px;
  padding: 10px 12px;
  border: 1px solid ${inputBorderColor};
  border-radius: 3px;
  color: #2d3448;
  box-shadow: none;
  outline: none;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

  @media (${screenSize.tablet}) {
    ${({ backgroundColor }: Props) => {
      if (backgroundColor) {
        return `background-color:${backgroundColor};`;
      } else {
        return `background-color: #fafbfc;`;
      }
    }}
    
    border-color: ${inputBorderColor};
    &:disabled {
      background-color: ${whiteColor};
      color: grey;
      cursor: not-allowed;
      border-color: ${inputBorderColor};
      &:hover {
        background-color: ${whiteColor};
        border-color: ${inputBorderColor};
        color: grey;
      }
      &:active,
      &:focus {
        background-color: ${whiteColor};
        border-color: ${inputBorderColor};
      }
    }
    &:hover {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
`;
export const Label = styled.label`
  font-size: 15px;
  color: #0f1d2a;
  opacity: 0.5;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
export const Star = styled.label`
  font-size: 15px;
  color: red;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
